import { Address } from 'components/form-fields/address-section/types'
import { InvoiceMedium, PaymentMethod, RegistrationSteps, Situation } from 'features/registration/types'
import { Language } from 'types/language'

// ENUMS

export enum BillingFieldKeys {
  DIFFERENT_CORRESPONDENCE_ADDRESS = 'differentCorrespondenceAddress',
  CORRESPONDENCE_ADDRESS = 'correspondenceAddress',
  PAYMENT_METHOD = 'paymentMethod',
  INVOICE_MEDIUM = 'invoiceMedium',
  IBAN = 'iban'
}

export enum BirthDateFields {
  DAY = 'day',
  MONTH = 'month',
  YEAR = 'year'
}

export enum InputGroupKeys {
  PERSONAL_DATA = 'personalData',
  METER_DETAILS = 'meterDetails',
  BILLING = 'billing',
  OVERVIEW = 'overview'
}

export enum OverviewFieldKeys {
  UPLOAD = 'upload',
  SIGNATURE = 'signature'
}

export enum PersonalDataFieldKeys {
  IS_COMPANY = 'isCompany',
  COMPANY_NUMBER = 'companyNumber',
  LEGAL_FORM = 'legalForm',
  COMPANY_NAME = 'companyName',
  SUBJECT_TO_VAT = 'subjectToVat',
  FIRSTNAME = 'firstName',
  LASTNAME = 'lastName',
  EMAIL = 'email',
  REPEAT_EMAIL = 'repeatEmail',
  MOBILE_PHONE = 'mobilePhone',
  DATE_OF_BIRTH = 'dateOfBirth',
  LANGUAGE = 'language',
  DELIVERY_ADDRESS = 'deliveryAddress'
}

export enum MeterDetailsFieldKeys {
  SITUATION = 'situation',
  METER_READING_MONTH = 'meterReadingMonth',
  CONTRACT_START_DATE = 'contractStartDate',
  KNOWS_METER_DETAILS = 'knowsMeterDetails',
  ELECTRICITY = 'electricity',
  GAS = 'gas'
}

// TYPES

export type BillingInputs = {
  [BillingFieldKeys.DIFFERENT_CORRESPONDENCE_ADDRESS]: boolean
  [BillingFieldKeys.CORRESPONDENCE_ADDRESS]: Address
  [BillingFieldKeys.PAYMENT_METHOD]: PaymentMethod
  [BillingFieldKeys.INVOICE_MEDIUM]: InvoiceMedium
  [BillingFieldKeys.IBAN]: string
}

export type BirthDate = {
  [BirthDateFields.DAY]: string
  [BirthDateFields.MONTH]: string
  [BirthDateFields.YEAR]: string
}

export type InputGroups = {
  [InputGroupKeys.PERSONAL_DATA]: PersonalDataInputs
  [InputGroupKeys.METER_DETAILS]: MeterDetailsInputs
  [InputGroupKeys.BILLING]: BillingInputs
  [InputGroupKeys.OVERVIEW]: OverviewInputs
}

export type MeterDetailsInputs = {
  [MeterDetailsFieldKeys.SITUATION]: Situation
  [MeterDetailsFieldKeys.METER_READING_MONTH]: number | null
  [MeterDetailsFieldKeys.CONTRACT_START_DATE]: Date
  [MeterDetailsFieldKeys.KNOWS_METER_DETAILS]: boolean
  [MeterDetailsFieldKeys.ELECTRICITY]: {
    total: number | null
    day: number | null
    night: number | null
    exclNight: number | null
    ean: number | null
    eanExclNight: number | null
    meterNumber: string | null
  }
  [MeterDetailsFieldKeys.GAS]: {
    total: number | null
    ean: number | null
    meterNumber: string | null
  }
}

export type OverviewInputs = {
  [OverviewFieldKeys.UPLOAD]?: {
    name: string
    file: string
  }
  [OverviewFieldKeys.SIGNATURE]?: string
}

export type PersonalDataInputs = {
  [PersonalDataFieldKeys.IS_COMPANY]: boolean
  [PersonalDataFieldKeys.COMPANY_NUMBER]?: string
  [PersonalDataFieldKeys.LEGAL_FORM]?: string
  [PersonalDataFieldKeys.COMPANY_NAME]?: string
  [PersonalDataFieldKeys.SUBJECT_TO_VAT]?: boolean
  [PersonalDataFieldKeys.FIRSTNAME]: string
  [PersonalDataFieldKeys.LASTNAME]: string
  [PersonalDataFieldKeys.EMAIL]: string
  [PersonalDataFieldKeys.REPEAT_EMAIL]: string
  [PersonalDataFieldKeys.MOBILE_PHONE]: string
  [PersonalDataFieldKeys.DATE_OF_BIRTH]: BirthDate
  [PersonalDataFieldKeys.LANGUAGE]: Language
  [PersonalDataFieldKeys.DELIVERY_ADDRESS]: Address
}

export type RegistrationStore = {
  isLoading: boolean
  error: boolean
  currentStep: RegistrationSteps
  registrationFlow: RegistrationSteps[]
  inputs: InputGroups
}
